
import packageJson from '../../../package.json';
import React from 'react';
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className="text-center pt-4">
      <p className="copyright ng-binding">
        <span id="appVersionNumber">{packageJson.version}</span>&nbsp;
        <strong>© Copyright {year} <a rel="noreferrer" href="http://www.t4project.com/" target="_blank">T4 Project</a>.</strong>&nbsp;
        {t('footer.rights')}
      </p>
    </div>
  )
}

export default Footer

